var _g, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHurtsLittleSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_319_1586)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 18,
    stroke: "#A2EE4E",
    strokeWidth: 3.2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 41C34.2843 41 41 34.2843 41 26C41 17.7157 34.2843 11 26 11C17.7157 11 11 17.7157 11 26C11 34.2843 17.7157 41 26 41Z",
    fill: "#A2EE4E",
    stroke: "#A2EE4E",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 30.5C31.1512 32.2938 28.8876 33.5 26 33.5C23.1124 33.5 20.8487 32.2938 19.5 30.5",
    stroke: "#406B0F",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.375 25.375C21.7557 25.375 22.875 24.2557 22.875 22.875C22.875 21.4943 21.7557 20.375 20.375 20.375C18.9943 20.375 17.875 21.4943 17.875 22.875C17.875 24.2557 18.9943 25.375 20.375 25.375Z",
    fill: "#406B0F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.625 25.375C33.0057 25.375 34.125 24.2557 34.125 22.875C34.125 21.4943 33.0057 20.375 31.625 20.375C30.2443 20.375 29.125 21.4943 29.125 22.875C29.125 24.2557 30.2443 25.375 31.625 25.375Z",
    fill: "#406B0F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_319_1586",
    x: 0.0000243187,
    y: 0.00039053,
    width: 52,
    height: 51.9992,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.2,
    result: "effect1_foregroundBlur_319_1586"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHurtsLittleSelected);
export default __webpack_public_path__ + "static/media/hurts-little-selected.94bda265961e4184cc287dff8ba3fbe6.svg";
export { ForwardRef as ReactComponent };